import { Ref } from 'react';
import { cn } from '@anytag/shared-utils';
import { Checkbox as AnyUICheckbox, CheckboxProps as AnyUICheckboxProps } from '@anyui/core';
import { HelpIcon, HelpIconProps } from '../Icon';
import { Tooltip, TooltipProps } from '../Tooltip';
import { TextCutter, TextCutterProps } from '../TextCutter';

export interface CheckBoxProps extends AnyUICheckboxProps, Pick<TextCutterProps, 'lines'> {
  ref?: Ref<HTMLInputElement>;
  hint?: HelpIconProps['help']; // question mark help
  help?: HelpIconProps['help']; // tooltip help
  customTooltipProps?: Omit<TooltipProps, 'help' | 'children' | 'title'>;
}

export const CheckBox = ({
  id,
  hint,
  help,
  lines,
  label,
  disabled,
  className,
  classNames,
  customTooltipProps,
  ref,
  ...restCheckboxProps
}: CheckBoxProps) => (
  <Tooltip
    id={id}
    place="top"
    {...customTooltipProps}
    help={(!disabled && help) || ''}
    withinPortal={customTooltipProps?.withinPortal ?? true}
  >
    <div ref={ref}>
      <AnyUICheckbox
        disabled={disabled}
        className={cn('checkbox-wrapper', className)}
        classNames={{
          ...classNames,
          checkbox: cn({ 'cursor-pointer!': !disabled }, classNames?.checkbox),
          label: cn('font-normal!', { 'cursor-pointer!': !disabled }, classNames?.label)
        }}
        label={
          label && hint ? (
            <div className="flex items-center gap-1">
              {typeof label === 'string' ? <TextCutter text={label} lines={lines} /> : label}
              {hint && <HelpIcon help={hint} />}
            </div>
          ) : typeof label === 'string' ? (
            <TextCutter text={label} lines={lines} />
          ) : (
            label
          )
        }
        {...restCheckboxProps}
      />
    </div>
  </Tooltip>
);
